export default {"src":"/_next/static/media/OKE.5957fd79.svg","height":18,"width":18};